import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  makeStyles,
  AppBar,
  Toolbar,
  IconButton,
  Hidden,
  Typography,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Link,
  Icon,
  Tooltip,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import LanguageIcon from '@material-ui/icons/Translate';
import userManager, { userIsInAnyRole } from "../../../auth/userManager";
import logo from "../../../assets/11pets_logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from 'react-redux';
import { compose } from "../../../utils/compose";
import { withRouter, NavLink as RouterLink } from 'react-router-dom';
import { availableLanguages } from "../../../i18n/i18n";
import { useTranslation } from "react-i18next";
import { settingsActions } from '../../../store/actions/settings/settings';
import { notificationActions } from '../../../store/actions/notifications/notifications';
import {httpClient, exportDataBaseUrl} from "../../../http-client/http-client";

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  menuButton: {
    marginRight: theme.spacing(2)
  },
  title: {

  },
  grow: {
    flexGrow: 1,
  },
  leftIcon: {
    marginRight: theme.spacing(1),
  },
  language: {
    margin: theme.spacing(0, 1, 0, 0.5),
    textTransform: "uppercase",
  }
}));

const RLink = React.forwardRef((props, ref) => (
  <RouterLink innerRef={ref} {...props} />
))

const PetsAppBar = props => {
  const { onDrawerToggle, title, language, onChangeLanguage, user, access_token, onShowNotification } = props;
  const classes = useStyles();
  const [ anchorEl, setAnchorEl ] = useState(null);
  const [ langAnchorEl, setLangAnchorEl] = useState(null);
  const { t, i18n } = useTranslation(null, { useSuspense: false});


  const isMenuOpen = Boolean(anchorEl);
  const isLangSelectorOpen = Boolean(langAnchorEl);

  useEffect(() => {
    // i18n.changeLanguage(language);
  }, [])

  const goToDashboard = event => {
    if(!userIsInAnyRole(user, ["Owner"])) {
      window.location.href = process.env.REACT_APP_PORTALV2_ENDPOINT;
    }
    else {
      window.location.href = process.env.REACT_APP_PORTAL_ENDPOINT;
    }
  }

  const exportData = async event => {
    const url = `${exportDataBaseUrl}`;

    try {
      const data = await httpClient.post(url, access_token);

      const notification = {
        message: t("exportDataMessage"),
        options: {
          variant: "success"
        }
      };
      onShowNotification(notification);
    } catch (error) {
      const notification = {
        message: t(error.error.HumanError),
        options: {
          variant: "warning"
        },
        hasCloseButton: true
      };
      onShowNotification(notification);
    }
  }

  const signoutHandler = event => {
    userManager.signoutRedirect();
  };

  function handleProfileMenuOpen(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleMenuClose() {
    setAnchorEl(null);
  }

  function handleLangSelectorMenuOpen(event) {
    setLangAnchorEl(event.currentTarget);
  }

  function handleLangSelectorClose() {
    setLangAnchorEl(null);
  }

  function switchLanguageHandler(lang) {
    setLangAnchorEl(null);
    i18n.changeLanguage(lang.code)
      .then(
        () => {
          onChangeLanguage(lang.code);
        }
      );
  }


  const menuId = 'app-bar-account-menu';
  const renderUserMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
      getContentAnchorEl={null}
      id={menuId}
      keepMounted
      open={isMenuOpen}
      onClose={handleMenuClose}
      >
        <MenuItem onClick={goToDashboard}>
          <ListItemIcon>
            <FontAwesomeIcon icon="sign-out-alt" />
          </ListItemIcon>
          <ListItemText>
            {t('dashboardWeb')}
          </ListItemText>
        </MenuItem>
        <Divider></Divider>
        <MenuItem onClick={exportData}>
          <ListItemIcon>
            <FontAwesomeIcon icon="sign-out-alt" />
          </ListItemIcon>
          <ListItemText>
            {t('exportDataTitle')}
          </ListItemText>
        </MenuItem>
        <Divider></Divider>
        <MenuItem onClick={signoutHandler}>
          <ListItemIcon>
            <FontAwesomeIcon icon="sign-out-alt" />
          </ListItemIcon>
          <ListItemText>
            {t('logout')}
          </ListItemText>
        </MenuItem>
      </Menu>
  );

  const langSelectorId = 'app-bar-lang-selector';
  const renderLanguageSelector = (
    <Menu
      anchorEl={langAnchorEl}
      anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
      getContentAnchorEl={null}
      id={langSelectorId}
      keepMounted
      open={isLangSelectorOpen}
      onClose={handleLangSelectorClose}
      >
        {availableLanguages.map(l => <MenuItem key={l.code} onClick={() => switchLanguageHandler(l)}>{l.name}</MenuItem>)}
      </Menu>
  )

  return (
    <>
    <AppBar position="sticky" color="primary" elevation={0}>
      <Toolbar>
        <Hidden mdUp>
          <IconButton
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="Menu"
            onClick={onDrawerToggle}
          >
            <MenuIcon />
          </IconButton>
        </Hidden>

        <Typography variant="h6">{t(title)}</Typography>

        <div className={classes.grow} />

        <Tooltip title={t('changeLanguage')}>
          <IconButton
            aria-label={t('changeLanguage')}
            aria-controls={langSelectorId}
            aria-haspopup="true"
            onClick={handleLangSelectorMenuOpen}
            color="inherit">
              <LanguageIcon />
          </IconButton>
        </Tooltip>
        <span className={classes.language}>{i18n.language || language}</span>
        <IconButton
          edge="end"
          aria-label="Account of current user"
          aria-controls={menuId}
          aria-haspopup="true"
          onClick={handleProfileMenuOpen}
          color="inherit"
          >
            <AccountCircleIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
    {renderUserMenu}
    {renderLanguageSelector}
    </>
  );
};

PetsAppBar.propTypes = {
  onDrawerToggle: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};

const mapStateToProps = state => {
  return {
    user: state.oidc.user,
    menu: state.navigation.menu,
    menuIsReady: state.navigation.isReady,
    title: state.navigation.title,
    language: state.settings.language,
    access_token: state.oidc.user.access_token,
  };
}

const mapDispatchToProps = dispatch => ({
  onChangeLanguage: (langIsoCode) => dispatch(settingsActions.changeLanguage(langIsoCode)),
  onShowNotification: nt => dispatch(notificationActions.enqueueSnackbar(nt)),
});

var composed = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(PetsAppBar)

export default composed;
